import { Avatar } from "@mui/material";
import React from "react";

export const removePrefix = (inputString) => {
  // Define an array of prefixes to remove
  const prefixes = ["Mr.", "Mrs.", "Ms.", "Dr."];

  // Use a regular expression to match any of the prefixes followed by a space
  const regex = new RegExp(`^(${prefixes.join("|")})\\s`, "i");

  // Replace the matched prefix with an empty string
  return inputString.replace(regex, "");
};

const TextAvatar = (props) => {
  return (
    <>
      <Avatar
        variant={!props?.circle && "rounded"}
        sx={{
          marginRight: props?.marginRight || "25px",
          height: props?.height || "45px",
          width: props?.width || "45px",
          ...props?.sx,
        }}
        src={props?.url || ""}
        alt={props?.text ? removePrefix(props?.text)?.[0]?.toUpperCase() : "."}
      >
        {props?.url
          ? ""
          : props?.text?.[0]
          ? removePrefix(props?.text)?.[0]?.toUpperCase()
          : "."}
      </Avatar>
    </>
  );
};

export default TextAvatar;
